<template>
  <div class="animated fadeIn disable-text-select" @keyup.enter="onFilter"
    style="overflow: auto;  padding-bottom: 6rem; padding-left: 4px; padding-right: 4px;">
    <div class="form-group row">
      <div class="w-100">
        <label> Gerente:</label>
        <div class="input-group w-100">
          <b-form-select v-model="form.usuarioId.value" :options="form.usuarioId.options" class="mb-3" >
            <template slot="first">
              <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
            </template>
          </b-form-select>
        </div>
      </div>
      <div class="w-100">
        <label> Período:</label>
        <div class="input-group w-100">
          <b-form-select v-model="form.periodoId.value" :options="form.periodoId.options" class="mb-3" >
            <template slot="first">
              <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
            </template>
          </b-form-select>
        </div>
      </div>
    </div>

    <div class="form-group row pt-2">
      <div class="w-100 pt-2">
        <button type="button" class="btn rounded-4 btn-third w-100" v-on:click="onFilter">
          Filtrar
        </button>
      </div>
      <div class="w-100 pt-2">
        <button type="button" class="btn rounded-4 btn-default w-100" v-on:click="onClearFilters">
          Limpar Filtros
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import DespesasSearch from './search.js'
export default DespesasSearch
</script>

<style lang="scss" scoped>

.disable-text-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.animated.fadeIn {
  padding-bottom: 2rem;
}

.animated.fadeIn::-webkit-scrollbar {
  display: none;
}

.form-group {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/reports/despesas/search/search.vue